import common from '@/validator/CommonRules'

/**
 * ログイン バリデーションルール
 */
export default {
  userId: 'required|' + common.userId,
  password: 'required|' + common.passwordRule,
}
